import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';

export const medicineCardConfig = (drugsTypes: any) =>
  [
    {
      label: 'Название препарата',
      key: 'name',
      type: 'text',
      validation: [Validators.required()],
    },
    {
      label: 'Вид препарата',
      key: 'drugTypeId',
      type: 'select',
      validation: [Validators.required()],
      payload: {
        options: drugsTypes,
        fieldNames: {
          label: 'name',
          value: 'id',
        },
      },
    },
  ] as IFormItem[];
